import {
    addPlansToMember,
    getMembers,
    addMember,
    updateMember,
    deleteMember,
    updateMembersMembershipPlan,
    getMembersBirthdaysByDateRange,
    inviteMemberByEmail,
    getWaitingMembers,
    getClassesForPlans,
    assignClassesToPlan,
    resendInvitation,
    updateMemberStatus,
} from './membersRequestConfigs';

class MembersApi {
    getMembers = getMembers;
    addMember = addMember;
    updateMember = updateMember;
    addPlansToMember = addPlansToMember;
    deleteMember = deleteMember;
    updateMembersMembershipPlan = updateMembersMembershipPlan;
    getMembersBirthdaysByDateRange = getMembersBirthdaysByDateRange;
    inviteMemberByEmail = inviteMemberByEmail;
    getWaitingMembers = getWaitingMembers;
    getClassesForPlans = getClassesForPlans;
    assignClassesToPlan = assignClassesToPlan;
    resendInvitation = resendInvitation;
    updateStatus = updateMemberStatus;
}

class MembersFactory {
    members = MembersApi;
    create() {
        return new this.members();
    }
}

export const members = new MembersFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/MembersApi/index.js